import { CSSProperties } from 'react';
import { Link } from 'react-router';

import { Box, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useMediaQuery } from '~/hooks';
import { IProfessionalCardRating } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';
import { getTruncatedNameStyle } from './cardText';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** whiteSpace/minWidth have no DS Row prop */
const nameRowStyle: CSSProperties = { whiteSpace: 'nowrap', minWidth: 0 };
/** keeps rating + divider + Profile link from shrinking when the name truncates */
const ratingClusterStyle: CSSProperties = { flexShrink: 0 };
/** 2px vertical divider; DS Box has no background prop */
const dividerStyle: CSSProperties = { backgroundColor: colors.neutral['600'] };
/** strip the default anchor underline around the DS Typography */
const profileLinkStyle: CSSProperties = { textDecoration: 'none' };

interface IProfessionalNameRowProps {
  id: string;
  fullname: string;
  rating?: IProfessionalCardRating;
  isAvailable?: boolean;
}

export const ProfessionalNameRow = ({
  id,
  fullname,
  rating,
  isAvailable = true,
}: IProfessionalNameRowProps) => {
  const [isLargeScreen] = useMediaQuery(['xl']);

  return (
    <Row align="center" gap={2} style={nameRowStyle}>
      <Typography
        as="span"
        bold
        size="heading_4"
        title={fullname}
        style={getTruncatedNameStyle(isLargeScreen ? 500 : 'min(15vw, 500px)', isAvailable)}
      >
        {fullname}
      </Typography>

      {rating != null && (
        <Row align="center" gap={2} style={ratingClusterStyle}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />

          <Box width="2px" height="20px" style={dividerStyle} />

          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={profileLinkStyle}>
              <Typography bold variant="body1" color={colors.secondary['500']}>
                Profile
              </Typography>
            </Link>
          ) : (
            <Typography bold variant="body1" color={colors.secondary['200']}>
              Profile
            </Typography>
          )}
        </Row>
      )}
    </Row>
  );
};
